export default __webpack_public_path__ + "static/media/icon_facebook.032fe566.svg";